"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FamilySubsidies = void 0;
var react_1 = __importDefault(require("react"));
var strings_1 = __importDefault(require("../strings"));
var Checkbox_1 = __importDefault(require("@material-ui/core/Checkbox"));
var Link_1 = __importDefault(require("@material-ui/core/Link"));
var FormControlLabel_1 = __importDefault(require("@material-ui/core/FormControlLabel"));
var Grid_1 = __importDefault(require("@material-ui/core/Grid"));
var Radio_1 = __importDefault(require("@material-ui/core/Radio"));
var RadioGroup_1 = __importDefault(require("@material-ui/core/RadioGroup"));
var styles_1 = require("@material-ui/core/styles");
var Typography_1 = __importDefault(require("@material-ui/core/Typography"));
var useStyles = styles_1.makeStyles(function (theme) { return ({
    subsidy: {
        fontSize: 18,
        fontWeight: 500,
    },
    subsidyOptions: {
        marginLeft: theme.spacing(4),
        marginRight: theme.spacing(4),
    },
}); });
var FamilySubsidies = function (props) {
    var _a;
    var classes = useStyles(props);
    var _b = react_1.default.useState(((_a = props.parentSubsidies) === null || _a === void 0 ? void 0 : _a.length) > 0), hasSubsidy = _b[0], setHasSubsidy = _b[1];
    var _c = react_1.default.useState(props.parentSubsidies || []), subsidies = _c[0], setSubsidies = _c[1];
    react_1.default.useEffect(function () {
        var _a;
        setSubsidies(props.parentSubsidies || []);
        setHasSubsidy(((_a = props.parentSubsidies) === null || _a === void 0 ? void 0 : _a.length) > 0);
    }, [props.parentSubsidies]);
    var onChangeSubsidy = function (e) {
        if (e.target.value === strings_1.default.yes) {
            setHasSubsidy(true);
        }
        else {
            setHasSubsidy(false);
            setSubsidies([]);
            props.onChange([]);
        }
    };
    var onToggleSubsidy = function (e, key) {
        var s = [].concat(subsidies);
        var idx = subsidies.indexOf(key);
        if (e.target.checked && (idx === -1)) {
            s.push(key);
        }
        else if (!e.target.checked && (idx > -1)) {
            s.splice(idx, 1);
        }
        setSubsidies(s);
        props.onChange(s);
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Grid_1.default, { container: true, spacing: 2 },
            react_1.default.createElement(Grid_1.default, { item: true, xs: 12 },
                react_1.default.createElement(Typography_1.default, { variant: "body1", className: classes.subsidy }, props.couponDisplay ? strings_1.default.subsidies.couponSubsidyLabel : strings_1.default.subsidies.subsidyLabel)),
            react_1.default.createElement(Grid_1.default, { item: true, xs: 12 },
                react_1.default.createElement(RadioGroup_1.default, { "aria-label": "subsidy", name: "subsidy-group", value: hasSubsidy ? strings_1.default.yes : strings_1.default.no, onChange: onChangeSubsidy },
                    react_1.default.createElement(FormControlLabel_1.default, { key: "choice-no", id: "choice-no", value: strings_1.default.no, label: props.couponDisplay ? strings_1.default.subsidies.couponNo : strings_1.default.no, control: react_1.default.createElement(Radio_1.default, { key: "radio-no", disabled: props.disabled }) }),
                    react_1.default.createElement(FormControlLabel_1.default, { key: "choice-yes", id: "choice-yes", value: strings_1.default.yes, label: props.couponDisplay ? strings_1.default.subsidies.couponYes : strings_1.default.yes, control: react_1.default.createElement(Radio_1.default, { key: "radio-yes", disabled: props.disabled }) })))),
        react_1.default.createElement(Grid_1.default, { container: true },
            react_1.default.createElement("div", { className: classes.subsidyOptions }, props.availableSubsidies.map(function (a) {
                return (react_1.default.createElement(Grid_1.default, { item: true, xs: 12 },
                    react_1.default.createElement(FormControlLabel_1.default, { control: react_1.default.createElement(Checkbox_1.default, { checked: subsidies.indexOf(a.code) > -1, onChange: function (e) { return onToggleSubsidy(e, a.code); }, disabled: props.disabled || !hasSubsidy, name: "cantext", color: "primary" }), label: a.url ? (react_1.default.createElement(Link_1.default, { href: a.url, target: "_blank", rel: "noreferrer" }, a.name)) : a.name })));
            })))));
};
exports.FamilySubsidies = FamilySubsidies;
